<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-4 h-4"
  >
    <path
      d="M7.99984 4V5"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="active ? 'url(#da_p0_blue)' : 'url(#da_p0_gray)'"
    />
    <path
      d="M12.2426 3.75736C14.5858 6.10051 14.5858 9.89949 12.2426 12.2426C9.89948 14.5858 6.10049 14.5858 3.75736 12.2426C1.41421 9.89948 1.41421 6.10049 3.75736 3.75736C6.10051 1.41421 9.89949 1.41421 12.2426 3.75736"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="active ? 'url(#da_p1_blue)' : 'url(#da_p1_gray)'"
    />
    <path
      d="M7.99984 12V11"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="active ? 'url(#da_p2_blue)' : 'url(#da_p2_gray)'"
    />
    <path
      d="M6 9.50333V9.50333C6 10.332 6.67133 11.0033 7.5 11.0033H8.59533C9.37067 11.0033 10 10.3747 10 9.59867V9.59867C10 8.95467 9.562 8.39333 8.93733 8.23667L7.06267 7.76667C6.438 7.61 6 7.04867 6 6.40467V6.40467C6 5.62867 6.62867 5 7.40467 5H8.5C9.32867 5 10 5.67133 10 6.5V6.5"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="active ? 'url(#da_p3_blue)' : 'url(#da_p3_gray)'"
    />
    <defs>
      <linearGradient id="da_p0_blue" x1="7.68183" y1="4.10714" x2="8.38671" y2="4.15162" gradientUnits="userSpaceOnUse">
        <stop stop-color="#5763FF" />
        <stop offset="1" stop-color="#C7CBFF" />
      </linearGradient>
      <linearGradient id="da_p0_gray" x1="7.68183" y1="4.10714" x2="8.38671" y2="4.15162" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
      <linearGradient id="da_p1_blue" x1="2.27586" y1="3.28571" x2="14.9011" y2="4.4808" gradientUnits="userSpaceOnUse">
        <stop stop-color="#5763FF" />
        <stop offset="1" stop-color="#C7CBFF" />
      </linearGradient>
      <linearGradient id="da_p1_gray" x1="2.27586" y1="3.28571" x2="14.9011" y2="4.4808" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
      <linearGradient id="da_p2_blue" x1="7.68183" y1="11.1071" x2="8.38671" y2="11.1516" gradientUnits="userSpaceOnUse">
        <stop stop-color="#5763FF" />
        <stop offset="1" stop-color="#C7CBFF" />
      </linearGradient>
      <linearGradient id="da_p2_gray" x1="7.68183" y1="11.1071" x2="8.38671" y2="11.1516" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
      <linearGradient id="da_p3_blue" x1="6.09195" y1="5.64321" x2="10.3212" y2="5.90996" gradientUnits="userSpaceOnUse">
        <stop stop-color="#5763FF" />
        <stop offset="1" stop-color="#C7CBFF" />
      </linearGradient>
      <linearGradient id="da_p3_gray" x1="6.09195" y1="5.64321" x2="10.3212" y2="5.90996" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  active?: boolean
}>()
</script>
